import { render, staticRenderFns } from "./tabFinanceCapitalExpenseRecord.vue?vue&type=template&id=3221b433&"
import script from "./tabFinanceCapitalExpenseRecord.vue?vue&type=script&lang=ts&"
export * from "./tabFinanceCapitalExpenseRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports